import { useState, useRef, useEffect } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import '../style-modal.scss';
import Auth from "../../../models/Auth";
import { List_SUBMIITED_REQUESTS } from "../../../store/actions/requestDetails";
import { CREATE_NEW_INQUIRY, CREATE_GUEST_INQUIRY, GET_PORTAL_INQUIRY_CATEGORIES } from "../../../store/actions/inquiry";
import { LIST_PROGRAM_DOCUMENT_TYPES } from '../../../store/actions/requestDocs'
import { UPLOAD_FILES_FOR_DOCUMENT, UPLOAD_GUEST_FILES_FOR_DOCUMENT } from "../../../store/actions/s3Service";
import { useDispatch } from "react-redux";
import { SET_OPEN_REQUEST_ACCESS } from '../../../store/actions/requestAccess';
import { GET_LIST_USER_NOTIFICATION } from "../../../store/actions/notificationUser";
import { t } from 'i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { DOCUMENT_CATEGORIES, STANDARD_REPORTS, SERVICE_DOCUMENTS, OTHER_DOCUMENTS } from "../../../constants/inquiry";
import { LIST_CIRCLE_REQUEST_DOCS } from '../../../store/actions/requestDocs';
import CustomSelect from "../../ServiceDocument/CustomSelect";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { toast } from "react-toastify";
import { PAGE_CODE, VOC_CATEGORY } from '../../../helper/constant';
import { PORTAL_INSTANCE } from '../../..';
import { SheetNames, translate } from "../../../helper/i18next-utils";
const commonCode = PAGE_CODE.COMMON_CODE;
const pageCode = PAGE_CODE.SUPPORT

const inquiryCategoriesRequiredRequestId = [
    "Extension of container rental contract", "Request Status"
]

const priority = [
    { value: 1, label: t(`${pageCode}.LabelHighest`) },
    { value: 2, label: t(`${pageCode}.LabelHigh`) },
    { value: 3, label: t(`${pageCode}.LabelMedium`) },
    { value: 4, label: t(`${pageCode}.LabelLowest`) },
    // { value: 5, label: t(`${pageCode}.LabelBlocker`) },
    // { value: 6, label: t(`${pageCode}.LabelMinor`) },
]

const SUPPORT_DEFAULT_PRIORITY = 2;
const MAX_INQUIRY_TEXT_LENGTH = 250;

function NewInquiry(props) {
    const [item, setItem] = useState({});
    const [categoryList, setCategoryList] = useState([]);
    const [allDocumentType, setAllDocumentType] = useState([]);
    const [selectedInquiryCategory, setSelectedInquiryCategory] = useState({});
    const [selectedDocumentCategory, setSelectedDocumentCategory] = useState();
    const [requests, setRequests] = useState([]);
    const [selectedRequest, setSelectedRequest] = useState()
    const [attachments, setAttachments] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const docCategories = DOCUMENT_CATEGORIES;
    const fileInputRef = useRef(null);
    const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
    const [selectedDocumentType, setSelectedDocumentType] = useState('');

    useEffect(() => {
        const fetchCircleRequestDocs = async () => {
            const isStandardReports = selectedDocumentCategory?.value === STANDARD_REPORTS;
            const isServiceDocuments = selectedDocumentCategory?.value === SERVICE_DOCUMENTS;

            if (isStandardReports && selectedRequest) {
                const responseData = await dispatch(LIST_CIRCLE_REQUEST_DOCS({ portalId: Auth.portalId, requestId: selectedRequest.value }));
                if (allDocumentType.length > 0) {
                    const filteredOptions = allDocumentType.filter(item => item.isCircleReport === true)
                        .filter(item => { return !responseData.some(doc => doc.documentInfo.name === item.documentInfo.name) })
                        .map(item => ({
                            value: item.documentInfo.name,
                            label: item.documentInfo.name
                        }));

                    setDocumentTypeOptions(filteredOptions)
                }
            } else if (isServiceDocuments && selectedRequest) {
                const filteredOptions = allDocumentType.filter(item => { return !item.isCircleReport }).map(item => ({
                    value: item.documentInfo.name,
                    label: item.documentInfo.name
                }));
                setDocumentTypeOptions(filteredOptions)
            }
        };
        fetchCircleRequestDocs();
    }, [selectedDocumentCategory, selectedRequest]);

    const onShow = async () => {
        setSelectedInquiryCategory('');
        setSelectedDocumentCategory('');
        setSelectedDocumentType('');
        setSelectedRequest('');
        setAttachments([])
        let item = props.item
        if (props.isGuest) {
            const generalInquiry = {
                name: VOC_CATEGORY.GeneralInquiry,
                label: translate(VOC_CATEGORY.GeneralInquiry, SheetNames.InquiryCategory),
            };
            setSelectedInquiryCategory(generalInquiry);
            onNewInquiry({ category: VOC_CATEGORY.GeneralInquiry, priority: SUPPORT_DEFAULT_PRIORITY, inquiryUsername: '', inquiryEmail: '', requestedBy: '' });
            return;
        }
        const categories = await onLoadData()
        if (props.fromSupport) {
            const generalInquiry = categories.find((c) => c.name === VOC_CATEGORY.GeneralInquiry);
            if (generalInquiry) {
                setSelectedInquiryCategory(generalInquiry);
            }
        }
        if (item?.id) {
            onNewInquiry(item)
        } else {
            if (item && item.isRequestDoc) {
                onNewInquiry(item)
            } else if (props.fromSupport) {
                onNewInquiry({ category: VOC_CATEGORY.GeneralInquiry, priority: SUPPORT_DEFAULT_PRIORITY })
            } else {
                onNewInquiry()
            }
        }
    }

    const validateInputs = (item, selectedDocumentCategory, selectedDocumentType) => {
        const { title, content, requestId, category, documentCategory, priority } = item;

        if (props.isGuest && (!item.inquiryUsername || item.inquiryUsername.trim().length === 0)) {
            toast.error(t('PlaceholderUsername'));
            return false;
        }

        if (props.isGuest && (!item.inquiryEmail || item.inquiryEmail.trim().length === 0)) {
            toast.error(t('PlaceholderEmail'));
            return false;
        }

        if (!category) {
            toast.error(t(`${pageCode}.MsgErrorPleaseSelectInquiryCategory`));
            return false;
        }

        if (category === 'Request for Documents' && (!documentCategory || !selectedDocumentCategory)) {
            toast.error(t(`${pageCode}.MsgErrorPleaseSelectDocumentCategory`));
            return false;
        }

        if ([STANDARD_REPORTS, SERVICE_DOCUMENTS].includes(documentCategory) && !requestId) {
            toast.error(t(`${pageCode}.MsgErrorPleaseSelectRequestId`));
            return false;
        }

        if (isRequiredRequestId() && !requestId) {
            toast.error(t(`${pageCode}.MsgErrorPleaseSelectRequestId`));
            return false;
        }

        if (!priority || priority === 0) {
            toast.error(t(`${pageCode}.MsgErrorPleaseSelectPriority`));
            return false;
        }
        if (category === 'Request for Documents' && documentCategory === "Standard Reports" && !selectedDocumentType) {
            toast.error(t(`${pageCode}.MsgErrorPleaseSelectDocumentType`));
            return false;
        }

        if (!title || title.trim().length === 0) {
            toast.error(t(`${pageCode}.MsgErrorPleaseEnterInquiryTitle`));
            return false;
        }

        if (!content || content.trim().length === 0) {
            toast.error(t(`${pageCode}.MsgErrorPleaseEnterDescription`));
            return false;
        }

        return true;
    };

    const onNext = async () => {
        const isValid = validateInputs(item, selectedDocumentCategory, selectedDocumentType);
        if (!isValid) return;

        if (props.isGuest) {
            const inquiryUsername = item.inquiryUsername.trim();
            const inquiryEmail = item.inquiryEmail.trim();
            const requestedBy = `${inquiryUsername} (${inquiryEmail})`;
            const data = await dispatch(CREATE_GUEST_INQUIRY({
                portalId: PORTAL_INSTANCE.pId,
                requestedBy: requestedBy,
                title: item.title,
                content: item.content,
                priority: item.priority || SUPPORT_DEFAULT_PRIORITY,
            }));
            if (!data?.id) return;

            if (attachments.length > 0) {
                await dispatch(UPLOAD_GUEST_FILES_FOR_DOCUMENT({
                    inquiryId: data.id,
                    requestId: 0,
                    file: attachments,
                    username: requestedBy,
                    portalId: PORTAL_INSTANCE.pId,
                    isTemplate: true,
                    isNewInquiry: true,
                }));
            }

            props.onNext({
                ...item,
                id: data.id,
            });
            return;
        }

        const payload = {
            inquiryCategoryId: parseInt(selectedInquiryCategory.value),
            requestId: parseInt(item.requestId),
            standardReportsType: item.selectedDocumentType,
            inquiryDocumentType: item.selectedDocumentType,
            title: item.title,
            content: item.content,
            documentCategory: item.documentCategory,
            priority: item.priority
        }
        if (item.documentCategory !== "Standard Reports") {
            payload.standardReportsType = ''
        }
        const data = await dispatch(CREATE_NEW_INQUIRY(payload));

        if (attachments.length > 0) {
            const pl = {
                inquiryId: data?.id,
                requestId: parseInt(item.requestId),
                docType: item.selectedDocumentType,
                file: attachments,
                userId: Auth.userId,
                username: Auth.username,
                portalId: Auth.portalId,
                isTemplate: true,
                isNewInquiry: true
            };

            await dispatch(UPLOAD_FILES_FOR_DOCUMENT(pl));
        }

        await dispatch(GET_LIST_USER_NOTIFICATION({ limit: 30, enableWeb: true }));
        props.onNext({
            ...item,
            id: data?.id
        })
    }

    const onNewInquiry = async (item) => {
        let newItem = {
            id: 0,
            documentCategory: item?.documentCategory,
            title: item?.title,
            category: item?.category,
            status: item?.status,
            responseBy: item?.responseBy,
            requestId: item?.requestId,
            updatedAt: new Date(),
            requestedBy: Auth.username,
            requestedUserId: Auth.userId,
            content: item?.content,
            responseContent: item?.responseContent,
        }
        newItem = {
            ...newItem,
            ...item,
            id: (item && item.id) || 0,
        }
        setItem(newItem)
    }

    const onLoadData = async () => {
        let cate = [];
        const category = await dispatch(GET_PORTAL_INQUIRY_CATEGORIES({ portalId: Auth.portalId }));
        if (category) {
            cate = category.filter(item => item.name !== 'Request for Access').map((item) => ({ value: item.id, label: translate(item.name, SheetNames.InquiryCategory), name: item.name }));
            setCategoryList(cate);
        }

        const requestsList = await dispatch(List_SUBMIITED_REQUESTS());
        if (requestsList) {
            const tmp = requestsList.map((item) => ({ value: item.requestid, label: item.displayid }));
            setRequests(tmp);
        }

        const allDocumentType = await dispatch(LIST_PROGRAM_DOCUMENT_TYPES(Number(Auth.portalId)));
        setAllDocumentType(allDocumentType)
        return cate;
    }

    const onClose = () => {
        setSelectedInquiryCategory('');
        setSelectedDocumentCategory('');
        setSelectedRequest('');
        setSelectedDocumentType('');
    }

    const onChangePriority = (option) => {
        setItem({
            ...item,
            priority: option.value
        })
    }

    const onChangeCategory = (option) => {
        if (option.name === 'Request for Access') {
            onClose();
            props.onHide();
            dispatch(SET_OPEN_REQUEST_ACCESS(true));
        } else {
            setItem({
                ...item,
                category: option.name,
                documentCategory: '',
            })
        }
    }

    const onChangeRequest = (option) => {
        setSelectedDocumentType('');
        setItem({
            ...item,
            requestId: option.value
        })
    }

    const onChangeDocumentCategory = (option) => {
        setDocumentTypeOptions([])
        setSelectedDocumentType('')
        setSelectedRequest();
        if (option.value === OTHER_DOCUMENTS) {
            setItem({
                ...item,
                requestId: 0,
                documentCategory: option.value
            })
        } else {
            setItem({
                ...item,
                documentCategory: option.value
            })
        }
    }

    const onChangeInput = async (event) => {
        let { value, name } = event.target
        if (name === 'title' || name === 'content') {
            value = value.slice(0, MAX_INQUIRY_TEXT_LENGTH)
        }
        setItem({
            ...item,
            [name]: value
        })
    }

    const onInitRequestClose = () => {
        if (location.pathname === "/dashboard/support/new-inquiry") {
            navigate(-1)
        }
    }

    const onStandardReportsType = (option) => {
        if (!selectedRequest) {
            return toast.error(t(`${pageCode}.MsgErrorPleaseSelectRequestId`));
        }
        setItem({
            ...item,
            selectedDocumentType: option.value
        })
        setSelectedDocumentType(option);
    }

    const generateRequestIdField = () => {
        const isStandardReports = selectedDocumentCategory?.value === STANDARD_REPORTS;
        const isServiceDocuments = selectedDocumentCategory?.value === SERVICE_DOCUMENTS;

        let { category } = item
        if (category === 'Request for Documents' && (isStandardReports || isServiceDocuments)) {
            return (
                <>
                    <div className="col-3">
                        <CustomSelect
                            name="documentType"
                            label={<Form.Label className="title required">{t(`${pageCode}.LabelDocumentType`)}</Form.Label>}
                            options={documentTypeOptions}
                            value={selectedDocumentType}
                            placeholder={t(`${commonCode}.OptionSelect`)}
                            onChange={(selectOption) => onStandardReportsType(selectOption)}
                        />
                    </div>
                </>
            );
        }

        return null;
    };

    const generateDocumentCategoryField = () => {
        if (selectedInquiryCategory?.label === "Request for Documents") {
            return (
                <div className="col-3">
                    <CustomSelect
                        name={`documentCategory`}
                        label={<Form.Label className="title required">{t(`${pageCode}.LabelDocumentCategory`)}</Form.Label>}
                        options={docCategories}
                        value={selectedDocumentCategory}
                        isMulti={false}
                        placeholder={t(`${commonCode}.OptionSelect`)}
                        onChange={(selectOption) => {
                            setSelectedDocumentCategory(selectOption)
                            onChangeDocumentCategory(selectOption);
                        }}
                    />
                </div>
            );
        }
    }

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const newFiles = Array.from(event.target.files);
        setAttachments(prevAttachments => [...prevAttachments, ...newFiles]);
    };

    const handleRemoveFile = (fileToRemove) => {
        setAttachments(prevAttachments =>
            prevAttachments.filter(file => file !== fileToRemove)
        );
    };

    const isRequiredRequestId = () => {
        if (selectedInquiryCategory?.name === "Request for Documents" && [STANDARD_REPORTS, SERVICE_DOCUMENTS].includes(selectedDocumentCategory?.name)) {
            return true;
        }
        if (inquiryCategoriesRequiredRequestId.some(item => item === selectedInquiryCategory?.name)) {
            return true;
        }
        return false;
    }

    return (
        <>
            <Modal {...props} aria-labelledby="Create New Inquiry"
                backdrop="static"
                keyboard={false}
                centered={true}
                size="xl"
                onShow={onShow}
            >
                <Modal.Header closeButton onHide={onInitRequestClose}>
                    <Modal.Title className="text-center">{t(`${pageCode}.CreateNewInquiry`)}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-contact">
                    { !props.fromSupport && <div className="row">
                        <div className="col-3">
                            <CustomSelect
                                name={`inquiryCategory`}
                                label={<Form.Label className="title">{t(`${pageCode}.InquiryCategory`)}</Form.Label>}
                                options={categoryList}
                                value={selectedInquiryCategory}
                                isMulti={false}
                                isRequired={true}
                                placeholder={t(`${commonCode}.OptionSelect`)}
                                onChange={(selectOption) => {
                                    setSelectedInquiryCategory(selectOption);
                                    onChangeCategory(selectOption);
                                }}
                                // description={translate(selectedInquiryCategory.label ? selectedInquiryCategory.name : '', SheetNames.InquiryCategory, 'desc')}
                            />
                        </div>

                        {generateDocumentCategoryField()}

                        {selectedDocumentCategory?.value !== OTHER_DOCUMENTS && <div className="col-3">
                            <CustomSelect
                                name="requestId"
                                label={<Form.Label className="title">{t(`${pageCode}.RequestID`)}</Form.Label>}
                                options={requests}
                                value={selectedRequest || null}
                                isMulti={false}
                                isRequired={isRequiredRequestId()}
                                placeholder={t(`${commonCode}.OptionSelect`)}
                                onChange={(selectOption) => {
                                    setSelectedRequest(selectOption || null);
                                    onChangeRequest(selectOption || { value: null });
                                }}
                                isClearable={true}
                            />
                        </div>}

                        {generateRequestIdField()}

                        <div className="col-3">
                            <CustomSelect
                                name={`Priority`}
                                label={<Form.Label className="title">{t(`${pageCode}.LabelPriority`)}</Form.Label>}
                                options={priority}
                                isMulti={false}
                                isRequired={true}
                                placeholder={t(`${commonCode}.OptionSelect`)}
                                onChange={(selectOption) => {
                                    onChangePriority(selectOption);
                                }}
                            />
                        </div>
                    </div>}

                    {props.isGuest && (
                        <div className="row">
                            <div className="col-6">
                                <Form.Group className="mb-3" controlId="inquiryUsername">
                                    <Form.Label className="title2 required">{t('PlaceholderUsername')}</Form.Label>
                                    <Form.Control
                                        size="lg"
                                        name="inquiryUsername"
                                        type="text"
                                        value={item.inquiryUsername || ''}
                                        placeholder={t('PlaceholderUsername')}
                                        onChange={onChangeInput}
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-6">
                                <Form.Group className="mb-3" controlId="inquiryEmail">
                                    <Form.Label className="title2 required">{t('PlaceholderEmail')}</Form.Label>
                                    <Form.Control
                                        size="lg"
                                        name="inquiryEmail"
                                        type="text"
                                        value={item.inquiryEmail || ''}
                                        placeholder={t('PlaceholderEmail')}
                                        onChange={onChangeInput}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    )}

                    <div className="row" style={{ marginTop: "-10px" }}>
                        {selectedInquiryCategory?.label && <Form.Text className='text-hint' style={{ whiteSpace: "pre-wrap" }}>
                            <i className="fa fa-info-circle" aria-hidden="true" style={{ backgroundColor: 'black', color: "white", borderRadius: "50%" }}></i>&nbsp;{translate(selectedInquiryCategory?.label ? selectedInquiryCategory?.name : '', SheetNames.InquiryCategory, 'desc')}
                        </Form.Text>}
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <Form.Group className="mb-3" controlId="title">
                                <Form.Label className="title2 required">{t(`${pageCode}.InquiryTitle`)}</Form.Label>
                                <Form.Control size="lg" name="title" type="text" placeholder={t(`${pageCode}.Title`)} value={item.title || ''} maxLength={MAX_INQUIRY_TEXT_LENGTH} onChange={onChangeInput} />
                            </Form.Group>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <Form.Group className="mb-3" controlId="content">
                                <Form.Label className="title2 required">{t(`${pageCode}.LabelDescription`)}</Form.Label>
                                <Form.Control as="textarea" name="content" placeholder={t(`${pageCode}.LabelDescription`)} rows={3} value={item.content || ''} maxLength={MAX_INQUIRY_TEXT_LENGTH} onChange={onChangeInput}></Form.Control>
                            </Form.Group>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <Form.Group controlId="template">
                                <Form.Label className="title2">{t(`${pageCode}.Attachment`)}</Form.Label>
                                <div className="table-inquiry">
                                    <table className="table mb-0">
                                        <thead>
                                            <th>{t(`${pageCode}.LabelName`)}</th>
                                            <th width="20%">{t(`${pageCode}.LabelActions`)}</th>
                                        </thead>
                                        <tbody>
                                            {(attachments && attachments.length > 0) && attachments.map((attachment, index) => (
                                                <tr key={index}>
                                                    <td> <i className="fa fa-file-excel-o" aria-hidden="true"></i>{attachment.name} </td>
                                                    <td>
                                                        <Button variant="outline-danger" size="sm" onClick={() => handleRemoveFile(attachment)}> <FontAwesomeIcon icon={faTrash} /> {t('Delete')} </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>

                                    <Button className='btn-outline-info btn-full-col mt-2 w-100' variant='outline-info' onClick={handleButtonClick} >
                                        <FontAwesomeIcon icon={faPlus}></FontAwesomeIcon>
                                    </Button>
                                    <input type="file" multiple ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
                                </div>
                            </Form.Group>
                        </div>
                    </div>

                    {!props.isGuest && (
                    <div className="custom-box d-flex align-items-center justify-content-between mt-2" style={{ height: "50px", borderRadius: "10px", backgroundColor: "#F9F9F9" }}>
                        <div className="d-flex align-items-center ml-3" style={{ fontSize: "0.75rem", color: "rgba(102, 102, 102, 1)" }}>
                            {t(`${pageCode}.FindAnswersToCommonlyAskedQuestionsOnTheFAQpage`)}
                        </div>

                        <div className="mr-3"
                            style={{ cursor: "pointer", marginLeft: "auto", color: "rgba(0, 102, 255, 1)", fontWeight: "500", fontSize: "12px" }}
                            onClick={async () => navigate(`/dashboard/support/faq?pId=${Auth.portalId}`)}>
                            {t(`${pageCode}.GoToTheFAQ`)}
                        </div>
                    </div>
                    )}

                </Modal.Body>
                <Modal.Footer style={{ border: 'none' }}>
                    <div className="dlg-btns text-center" style={{ margin: 'auto' }}>
                        <Button variant="outline-secondary" className="btn-outline-secondary mr-2" onClick={() => { onClose(); props.onHide() }}> {t(`${pageCode}.Cancel`)} </Button>
                        <Button variant="default" 
                        disabled={(props.isGuest && ((!item.inquiryUsername || item.inquiryUsername.trim().length === 0) || (!item.inquiryEmail || item.inquiryEmail.trim().length === 0) || (!item.title || item.title.trim().length === 0) || (!item.content || item.content.trim().length === 0)))
                            || (!props.isGuest && ((!item.title || item.title.trim().length === 0) || (!item.content || item.content.trim().length === 0)))
                        } 
                        onClick={onNext}>{t(`${pageCode}.Save`)}</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default NewInquiry;